module.exports = __webpack_public_path__ + "static/media/dragon_3.2651f2c0.jpg";